module.exports = __webpack_public_path__ + "static/media/roundImg1.f1f26930.svg";